var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 1536 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 938.665c0 47.13 38.205 85.335 85.334 85.335h1365.331c47.13 0 85.335-38.205 85.335-85.335 0-47.124-38.205-85.33-85.335-85.33h-1365.331c-47.128 0-85.334 38.205-85.334 85.33zM0 512c0 47.13 38.205 85.335 85.334 85.335h1365.331c47.13 0 85.335-38.205 85.335-85.335s-38.205-85.334-85.335-85.334h-1365.331c-47.128 0-85.334 38.205-85.334 85.334zM85.334 0c-47.128 0-85.334 38.205-85.334 85.334s38.205 85.333 85.334 85.333h1365.331c47.13 0 85.335-38.205 85.335-85.333s-38.205-85.334-85.335-85.334h-1365.331z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrips);
export default __webpack_public_path__ + "static/media/Strips.bae7f4bb473254b8936094c436b34bd1.svg";
export { ForwardRef as ReactComponent };